// extracted by mini-css-extract-plugin
export var form = "_3l-0";